import dynamicfunction from '../../utils/dynamicfunction';
import { useDispatch, useSelector } from 'react-redux';
import { getContentKeyAccToLang } from '../../utils/utils';
import { useLocation, useNavigate } from 'react-router';
import { downloadReport, sendReport } from '../../store/actions/fund-action';
import { useState } from 'react';
import { downloadBase64File } from '../../utils/functions';

export default () => {
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const { state } = useLocation();
  const { TextWeight, isArabic, direction } = dynamicfunction();

  const { fundsContent } = useSelector((state) => state.content);
  const { fund_loading } = useSelector((state) => state.fund);

  const [showModal, setShowModal] = useState(false)
  const [pdfUrl, setPdfUrl] = useState(null)

  const getContentKey = (key) => {
    return getContentKeyAccToLang(
      fundsContent?.web_funds_buy_order?.data?.attributes,
      key,
      isArabic
    );
  };

  const onPressView = (item) => {
    dispatch(downloadReport(item?.documentPayloadId, ((val) => {      
      setShowModal(true)
      setPdfUrl(val?.result)
    })))
  }
  const onPressDownload = (item) => {
    dispatch(downloadReport(item?.documentPayloadId, val => {
      downloadBase64File({
        base64Data: val?.result?.payload,
        fileName: val?.result?.fileName
      })
    }))
  }
  const onPressEmail = (item) => {
    const apiData = {
      fundId: item?.fundId,
      documentPayloadId: item?.documentPayloadId,
      fundReportId: item?.fundReportId
    }
    dispatch(sendReport(apiData))
  }

  return {
    TextWeight,
    navigate,
    isArabic,
    direction,
    state,
    onPressView,
    fund_loading,
    showModal,
    setShowModal,
    pdfUrl,
    onPressDownload,
    onPressEmail
  };

};
